export default __webpack_public_path__ + "static/15-6161d25113be87c5b4fa7a1224203022.jpg";